export const ItemTypes = {
    TASK: "task",
};

export const DRAG_HEIGHT = 54;
export const DRAG_WIDTH = 200;
export const DRAG_OFFSET_X = 75;
export const DRAG_OFFSET_Y = 27;

export const DRAG_SNAP_INCREMENT = 30 * 60 * 1000;
